import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=8c0aeb8e&scoped=true"
import script from "./SettingIndex.vue?vue&type=script&lang=js"
export * from "./SettingIndex.vue?vue&type=script&lang=js"
import style0 from "./SettingIndex.vue?vue&type=style&index=0&id=8c0aeb8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0aeb8e",
  null
  
)

export default component.exports